// extracted by mini-css-extract-plugin
module.exports = {"PasswordResetEmail":"yn_a bhc_px bhc_a bhc_w bhc_cw bhc_sb","PasswordResetEmail__title":"yn_b bhc_uj bhc_qk bhc_tu","PasswordResetEmail__subtitle":"yn_c bhc_tu"};